import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createARShapeAPI,
  deleteARShapeAPI,
  getAllARShapesAPI,
  getARShapeAPI,
  updateARShapeAPI,
  uploadARShapeFileAPI,
} from "../../api/ecommerce/ARShapesApi";

const initialState = {
  arShapes: [],
  arShape: {},
  uploadedFile: null,
  loading: false,
  addUpdateLoading: null,
  uploadLoading: null,
};

export const getAllARShapes = createAsyncThunk(
  "arShapes/getAllARShapes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllARShapesAPI();
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getARShape = createAsyncThunk(
  "arShapes/getARShape",
  async (arShapeId, { rejectWithValue }) => {
    try {
      const response = await getARShapeAPI(arShapeId);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const createARShape = createAsyncThunk(
  "arShapes/createARShape",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createARShapeAPI(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateARShape = createAsyncThunk(
  "arShapes/updateARShape",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateARShapeAPI(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteARShape = createAsyncThunk(
  "arShapes/deleteARShape",
  async (arShapeId, { rejectWithValue }) => {
    try {
      const response = await deleteARShapeAPI(arShapeId);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadARShapeFile = createAsyncThunk(
  "arShapes/uploadARShapeFile",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadARShapeFileAPI(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const arShapesSlice = createSlice({
  name: "arShapes",
  initialState,
  reducers: {
    clearARShape: (state) => {
      state.arShape = {};
    },
    clearARShapeUpload: (state) => {
      state.uploadedFile = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllARShapes.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllARShapes.fulfilled, (state, action) => {
      state.arShapes = action?.payload?.response || [];
      state.loading = true;
    });
    builder.addCase(getAllARShapes.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getARShape.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getARShape.fulfilled, (state, action) => {
      state.arShape = action?.payload?.response || {};
      state.loading = true;
    });
    builder.addCase(getARShape.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createARShape.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(createARShape.fulfilled, (state, action) => {
      state.arShape = action?.payload?.response || {};
      state.addUpdateLoading = true;
    });
    builder.addCase(createARShape.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(updateARShape.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(updateARShape.fulfilled, (state, action) => {
      state.arShape = action?.payload?.response || {};
      state.addUpdateLoading = true;
    });
    builder.addCase(updateARShape.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(deleteARShape.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(deleteARShape.fulfilled, (state) => {
      state.arShape = {};
      state.addUpdateLoading = true;
    });
    builder.addCase(deleteARShape.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(uploadARShapeFile.pending, (state) => {
      state.uploadLoading = false;
    });
    builder.addCase(uploadARShapeFile.fulfilled, (state, action) => {
      state.uploadedFile = action?.payload?.response || null;
      state.uploadLoading = true;
    });
    builder.addCase(uploadARShapeFile.rejected, (state) => {
      state.uploadLoading = null;
    });
  },
});

export const { clearARShape, clearARShapeUpload } = arShapesSlice.actions;
export default arShapesSlice.reducer;
